import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ImageWithShimmer from "../../component/ImageWithShimmer";
import { endPoints, GameplayEndPoints, PaymentEndpoints } from "../../constant/Environment";
import volt from "../../images/Lightning.svg";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Grid,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Box,
  Avatar,
  Switch,
  FormControlLabel,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSnackbarContext } from "../../component/SnackbarContext";
import { useDispatch, useSelector } from "react-redux";
import { addBetData, addData } from "../../Utility/API";
import { setLoading } from "../../redux/Reducers/GlobalReducer/globalSlice";
import { sumSC_credit_SC_Main } from "../../Utility/functions/Helper";
import CustomizedSwitches from "./CustomSwitch";
import { setShowSearchList } from "../../redux/Reducers/sidebarReducer/sidebarSlice";
import { FaTimes } from "react-icons/fa";
import { isMobile } from "react-device-detect";

const GameModal = (props) => {
  const { selectedGame, openGameModal, onModalClose } = props;
  const { game_name, game_creative, ext_url, game_id, provider,apikey } = selectedGame;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isSagaCoins, setIsSagaCoins] = useState(false);
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbarContext();
  const [isLoading, setIsLoading] = useState(false);
  const authState = useSelector((state) => state.auth);
  const { IsLoginData } = authState;
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();

  const handleClose = () => {
    onModalClose();
  };
  const playGame = async () => {
    if (isSagaCoins && IsLoginData?.account?.gc_balance <= 0) {
      const errorMessage = t('gameModal.addGoldCoins');
      showErrorSnackbar(errorMessage);
      return;
    }
    let totalAmount = sumSC_credit_SC_Main(
      IsLoginData?.account?.sc_credit,
      IsLoginData?.account?.sc_main
    );
    if (!isSagaCoins && totalAmount <= 0) {
      const errorMessage = t('gameModal.notEnoughSagaCoins');
      showErrorSnackbar(errorMessage);
      return;
    }
    setIsLoading(true);
    dispatch(setShowSearchList(false));
    let url = `${endPoints.api.CASINO_PLAY}`;
    let payload = {
      user_id: IsLoginData?.idUser,
      gameid: game_id,
      channel: "string",
      partnerid: "string",
      ticket: IsLoginData?.sessionId,
      customerid: "string",
      countrycode: "string",
      cashiertoken: "string",
      customercurrency: "string",
      playingWithCoin: isSagaCoins ? 1 : 2,
      balance: 0,
      jurisdiction: "string",
      gamesessionid: "string",
      gameref: "string",
      txid: "string",
      remotetxid: "string",
      amount: 0,
      txtype: "string",
      ended: "string",
      created_on: "",
      id: 0,
    };
    dispatch(setLoading(true));
    await addData(url, payload)
      .then(async (response) => {
        dispatch(setLoading(false));
        setIsLoading(false);
        if (response?.data?.status === "success") {
          onModalClose();
          console.log("selectedGame", selectedGame);
          const finalLaunchUrl = await fetchnetgamingurl(
            game_id,
            IsLoginData.sessionId,
            provider,
            apikey
          );
          navigate("/game", {
            state: { launchUrl: finalLaunchUrl},
          });
        } else {
          showErrorSnackbar(response.data.message);
        }
      })
      .catch((error) => {
        dispatch(setLoading(false));
        setIsLoading(false);
        showErrorSnackbar(t('gameModal.serverError'));
        console.error(error);
      });
  };

    const fetchnetgamingurl = async (gameId, sessionId,gameprovider,apikey) => {
    try {
      // const url = `${GameplayEndPoints?.apiBaseUrl}${GameplayEndPoints.api.GAME_LAUNCH_URL}`;
      const Base_url = GameplayEndPoints?.apiBaseUrl;
      const launchEndpointByProvider = {
        kagaming: GameplayEndPoints.api.KGAME_LAUNCH_URL,
        blazegaming: GameplayEndPoints.api.BLAZ_LAUNCH_URL,
        mascot: GameplayEndPoints.api.MASCOT_LAUNCH_URL,
        gametech: GameplayEndPoints.api.GAMETECH_LAUNCH_URL,
        revolver: GameplayEndPoints.api.REVOLVER_LAUNCH_URL
      };
      const launchEndpoint =
        launchEndpointByProvider[apikey] || GameplayEndPoints.api.GAME_LAUNCH_URL;
      const url = `${Base_url}${launchEndpoint}`;

      const data = {
        session_id: sessionId,
        provider: gameprovider,
        game_type: "slots",
        game_id: gameId,
        amount_type: "real",
        platform: isMobile ? "mobile" : "desktop",
        language: IsLoginData?.language || "EN",
        lobby_url: "",
        deposit_url: "",
        country_code: IsLoginData?.country || "US",
        context: {
          player_id: IsLoginData?.idUser,
          username: IsLoginData?.login || "",
          player_name: IsLoginData?.name || "",
          currency: IsLoginData?.currency || "USD",
          country: IsLoginData?.country || "US"
        }
      };

      const response = await addBetData(url, data);
          console.log("fetchnetgamingurl response", response?.data?.data?.launch_url,response.data.data);
      if (response?.data?.status == "success") {
        return response?.data?.data?.launch_url;
      } else {
        console.error("Failed to fetch live game URL");
      }
    } catch (error) {
      console.error("Error in fetchnetgamingurl:", error);
    }
  };


  const fetchLivegameUrl = async (gameId, sessionId) => {
    try {
      const url = `${PaymentEndpoints?.apiBaseUrl}${PaymentEndpoints?.api.LIVE_GAME_LAUNCH}`;
      const data = {
        launchAlias: gameId,
        sessionToken: sessionId,
      };

      const response = await addBetData(url, data);

      if (response?.data?.status == "success") {
        return response?.data?.data?.launchUrl;
      } else {
        console.error("Failed to fetch live game URL");
      }
    } catch (error) {
      console.error("Error in fetchLivegameUrl:", error);
    }
  };

  const fetchBgGameUrl = async (gameId, sessionId) => {
    try {
      const url = `${PaymentEndpoints?.apiBaseUrl}${PaymentEndpoints?.api.LIVE_BG_GAMEING_LAUNCH}`;
      const data = {
        launchAlias: gameId,
        sessionToken: sessionId,
      };

      const response = await addBetData(url, data);

      if (response?.data?.status == "success") {
        return response?.data?.data?.launchUrl;
      } else {
        console.error("Failed to fetch live game URL");
      }
    } catch (error) {
      console.error("Error in fetchBgGameUrl", error);
    }
  };

  const handleSwitchChange = () => {
    setIsSagaCoins(!isSagaCoins);
  };

  const TotalScBalance = sumSC_credit_SC_Main(
      IsLoginData?.account?.sc_credit,
      IsLoginData?.account?.sc_main
    );
  
  return (
    <React.Fragment>
      <Dialog
        className="game_modal ourmodal"
        //  fullScreen={fullScreen}
        //  maxWidth ="sm"
        open={openGameModal}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        // style={{
        //   width: "522px",
        //   // height: "auto",
        //   // maxHeight: "90vh",
        //   // margin: "auto",
        // }}
      >
        <DialogTitle id="responsive-dialog-title">
          {game_name}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 7,
              color: "white",
            }}
          >
            <FaTimes />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid item xs={12} sm={12}>
              <Card>
                <CardActionArea
                  style={{ position: "relative", background: "none" }}
                >
                  {parseInt(IsLoginData?.account?.ubalance) <= 0 ? (
                    <Typography
                      style={{
                        textAlign: "center",
                        color: "#ffcc00",
                        padding: "15px",
                        fontWeight: "bolder",
                        fontSize: isMobile ? "15px" : "19px",
                      }}
                    >
                      <strong>
                        {t('gameModal.balanceDepleted')}
                      </strong>
                    </Typography>
                  ) : (
                    <CardMedia
                      component="img"
                      height="100%"
                      src={
                        game_creative?.includes("https:")
                          ? `${game_creative}`
                          : `${endPoints.imageCDN}${game_creative}`
                      }
                      // src={`${endPoints?.imageCDN}${game_creative}`}
                      alt={game_name}
                      className="game_image"
                    />
                  )}
                </CardActionArea>
              </Card>
            </Grid>
          </DialogContentText>
          {/* <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{ marginTop: "10px" }}
          >
            <Typography
              style={{
                textAlign: "center",
                color: "#ffcc00",
                fontWeight: "bolder",
                fontSize: isMobile ? "15px" : "19px",
              }}
            >
              <strong>
                {t('gameModal.switchCoinsLine1')} <br />
                {t('gameModal.switchCoinsLine2')}
              </strong>
            </Typography>
          </Grid> */}

          {/* <Grid
            container
            alignItems="center"
            justifyContent="center"
            className="space_t"
            style={{ paddingBottom: "15px" }}
          >
            <Grid item>
              <Typography
                variant="body1"
                fontWeight="bold"
                style={{ marginRight: "20px" }}
              >
                {t('gameModal.sagaCoins')}
              </Typography>
            </Grid>

            <CustomizedSwitches
              checked={isSagaCoins}
              onChange={handleSwitchChange}
            />
            <Grid item>
              <Typography variant="body1" fontWeight="bold">
                {t('gameModal.goldCoins')}
              </Typography>
            </Grid>
          </Grid> */}
          <Button
            className="modal_game_modal"
            onClick={playGame}
            style={{
              background: isSagaCoins
                ? theme.palette.custom.yellow
                : theme.palette.white_green,
                marginTop: "20px",
            }}
          >
            {isLoading ? (
              <CircularProgress size={24} style={{ color: "white" }} />
            ) : (
              t('gameModal.playNow')
            )}
          </Button>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default GameModal;
